const DentalCleaning = (props: { fill: string }) => {
	return (
		<path
			fill={props.fill ?? '#0d2a5e'}
			d="M6.667 29.333v-12h2.667v-6.133l-4.533-4.533 5.333-5.333 1.867 1.867-3.467 3.467 3.467 3.467v7.2h2.667v12h-8zM17.333 29.333v-12h2.667v-4.167c-1.156-0.311-2.111-0.933-2.867-1.867s-1.133-2.033-1.133-3.3c0-1.467 0.522-2.722 1.567-3.767s2.3-1.567 3.767-1.567c1.467 0 2.722 0.522 3.767 1.567s1.567 2.3 1.567 3.767c0 1.267-0.378 2.367-1.133 3.3s-1.711 1.556-2.867 1.867v4.167h2.667v12h-8zM21.333 10.667c0.733 0 1.361-0.261 1.883-0.783s0.783-1.15 0.783-1.883-0.261-1.361-0.783-1.883c-0.522-0.522-1.15-0.783-1.883-0.783s-1.361 0.261-1.883 0.783-0.783 1.15-0.783 1.883c0 0.733 0.261 1.361 0.783 1.883s1.15 0.783 1.883 0.783zM9.333 26.667h2.667v-6.667h-2.667v6.667zM20 26.667h2.667v-6.667h-2.667v6.667z"
		></path>
	);
};

export default DentalCleaning;
